function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Website Analytics — the shared page header (title, window + comparison line, Site and
 * Segment chips). Rendered by the dashboard shell and by the Funnels and Heat pages so
 * every section under the switcher opens the same way.
 */
import React from "react";
import { rangeLabelFor, RANGES } from "../sales/territory-common";
import { getGlobalRange, getGlobalComp } from "../../functions/period-store";
import { getHosts, getWindow, safe, previousPreset, isCustomRange } from "./data";
export default class WebActivityHeader extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      hosts: null,
      win: null
    });
  }
  componentDidMount() {
    this._alive = true;
    this.meta();
  }
  componentDidUpdate(p) {
    if (p.range !== this.props.range) this.meta();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  range() {
    return this.props.range || getGlobalRange("this_month");
  }
  async meta() {
    const range = this.range();
    const [hosts, win] = await Promise.all([safe(getHosts(range)), safe(getWindow(range))]);
    if (this._alive) this.setState({
      hosts: hosts && hosts.hosts ? hosts.hosts : null,
      win: win || null
    });
  }
  subtitle() {
    const range = this.range();
    const comp = this.props.comp || getGlobalComp("prev_period");
    const {
      win
    } = this.state;
    const dates = win && win.startDate && win.endDate ? `${fmtD(win.startDate)} – ${fmtD(win.endDate)}` : "";
    const prev = previousPreset(range);
    const cmp = isCustomRange(range) || !prev ? "no comparison for this range" : comp === "prev_year" ? `vs ${prev.replace("_", " ")} (year-over-year arrives in phase 3)` : `vs ${prev.replace("_", " ")}`;
    const asOf = win && win.rollupAt ? `data through ${fmtD(win.rollupAt)}` : "as of the nightly rollup";
    return [rangeLabelFor(range, RANGES), dates, cmp, asOf].filter(Boolean).join(" · ");
  }
  render() {
    const {
      hosts
    } = this.state;
    return /*#__PURE__*/React.createElement("header", {
      className: "wa-hdr"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, this.props.title || "Website Analytics"), /*#__PURE__*/React.createElement("div", {
      className: "sub"
    }, this.subtitle())), hosts && hosts.length ? /*#__PURE__*/React.createElement("span", {
      className: "wa-chip",
      title: hosts.map(h => h.host).join(", ")
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Site"), " ", hosts.length === 1 ? hosts[0].host : `${hosts.length} sites`) : null, /*#__PURE__*/React.createElement("span", {
      className: "wa-chip"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Segment"), " All sessions"));
  }
}
// Date-only strings are calendar dates, not UTC instants: parse them as local so "2026-09-01" never shows as Aug 31.
export function fmtD(v) {
  let t = String(v || "").replace(" ", "T");
  if (/^\d{4}-\d{2}-\d{2}$/.test(t)) t += "T00:00:00";
  const d = new Date(t);
  return isNaN(d) ? "" : d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}